/* =========================================================================
   Galleria prodotto mobile — progressive enhancement solo ≤989px, page mode.
   Sposta le .product-drawer__media-item in un carosello scroll-snap e
   ricolloca .product-drawer__info. Inerte su desktop (DOM byte-identico).
   NB: prefisso cz- voluto (no Dawn slider-component, no controller reco).
   ========================================================================= */
(function () {
  'use strict';

  var MQ = '(max-width: 989px)';
  var REDUCE_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)');

  function scrollBehavior() {
    return REDUCE_MOTION.matches ? 'auto' : 'smooth';
  }

  function CzMobileGallery(root) {
    this.root = root;
    this.media = root.querySelector('.product-drawer__media');
    this.mq = window.matchMedia(MQ);
    this._moved = [];          // [{node, ph}] per ripristino esatto
    this._mgallery = null;
    this._track = null;
    this._slides = [];
    this._raf = 0;
    this._prevBtn = null;
    this._nextBtn = null;
    this._dots = null;
    this._onScroll = null;
    this._onPointerDown = null;
    this._onPointerMove = null;
    this._onClickCapture = null;

    this._onMqChange = this._onMqChange.bind(this);
    this.mq.addEventListener('change', this._onMqChange);

    if (this.mq.matches) this._build();
  }

  CzMobileGallery.prototype._onMqChange = function (e) {
    if (e.matches) this._build();
    else this._teardown();
  };

  CzMobileGallery.prototype._currentIndex = function () {
    if (!this._track) return 0;
    var w = this._track.clientWidth || 1;
    return Math.round(this._track.scrollLeft / w);
  };

  CzMobileGallery.prototype._syncNav = function () {
    if (!this._prevBtn) return;
    var i = this._currentIndex();
    var last = this._slides.length - 1;
    this._prevBtn.disabled = i <= 0;
    this._nextBtn.disabled = i >= last;
  };

  CzMobileGallery.prototype._buildNav = function () {
    if (this._slides.length <= 1) return;
    var self = this;
    var navs = document.createElement('div');
    navs.className = 'cz-mgallery__navs';

    function mk(dir, label, glyph) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'cz-mgallery__nav cz-mgallery__nav--' + dir;
      b.setAttribute('aria-label', label);
      b.textContent = glyph;
      b.addEventListener('click', function () {
        var w = self._track.clientWidth;
        self._track.scrollBy({ left: dir === 'next' ? w : -w, behavior: scrollBehavior() });
      });
      return b;
    }

    this._prevBtn = mk('prev', 'Immagine precedente', '‹');
    this._nextBtn = mk('next', 'Immagine successiva', '›');
    navs.appendChild(this._prevBtn);
    navs.appendChild(this._nextBtn);
    this._mgallery.appendChild(navs);

    this._onScroll = function () {
      if (self._raf) return;
      self._raf = requestAnimationFrame(function () {
        self._raf = 0;
        self._syncNav();
        self._syncPager();
      });
    };
    this._track.addEventListener('scroll', this._onScroll, { passive: true });
    this._syncNav();
  };

  CzMobileGallery.prototype._starHTML = function () {
    var tpl = document.querySelector('template[data-cz-mgallery-star]');
    return tpl ? tpl.innerHTML : '';
  };

  CzMobileGallery.prototype._buildPager = function () {
    if (this._slides.length <= 1) return;
    var self = this;
    var star = this._starHTML();
    var pager = document.createElement('div');
    pager.className = 'cz-mgallery__pager';
    pager.setAttribute('role', 'group');
    pager.setAttribute('aria-label', 'Seleziona immagine');

    this._dots = this._slides.map(function (slide, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'cz-mgallery__dot';
      b.setAttribute('aria-label', 'Vai alla foto ' + (i + 1));
      b.innerHTML =
        '<span class="cz-mgallery__dot-shape"></span>' +
        '<span class="cz-mgallery__dot-star">' + star + '</span>';
      b.addEventListener('click', function () {
        self._track.scrollTo({ left: i * self._track.clientWidth, behavior: scrollBehavior() });
      });
      pager.appendChild(b);
      return b;
    });

    this._mgallery.appendChild(pager);
    this._syncPager();
  };

  CzMobileGallery.prototype._syncPager = function () {
    if (!this._dots) return;
    var i = this._currentIndex();
    this._dots.forEach(function (d, idx) {
      var active = idx === i;
      d.classList.toggle('is-active', active);
      if (active) d.setAttribute('aria-current', 'true');
      else d.removeAttribute('aria-current');
    });
  };

  CzMobileGallery.prototype._bindTapGuard = function () {
    var startX = 0, startY = 0, moved = false;

    this._onPointerDown = function (e) {
      startX = e.clientX; startY = e.clientY; moved = false;
    };
    this._onPointerMove = function (e) {
      if (Math.abs(e.clientX - startX) > 10 || Math.abs(e.clientY - startY) > 10) {
        moved = true;
      }
    };
    // Cattura: intercetta prima del listener su document della lightbox.
    this._onClickCapture = function (e) {
      var wasMoved = moved;
      moved = false;
      if (wasMoved) {
        e.preventDefault();
        e.stopPropagation();
      }
    };

    this._mgallery.addEventListener('pointerdown', this._onPointerDown, { passive: true });
    this._mgallery.addEventListener('pointermove', this._onPointerMove, { passive: true });
    this._mgallery.addEventListener('click', this._onClickCapture, true);
  };

  // Sostituisce `node` con un segnaposto e lo restituisce (per ripristino).
  CzMobileGallery.prototype._detach = function (node) {
    var ph = document.createComment('cz-mgallery-ph');
    node.parentNode.replaceChild(ph, node);
    this._moved.push({ node: node, ph: ph });
    return node;
  };

  CzMobileGallery.prototype._build = function () {
    if (!this.media || this.root.dataset.czMgallery === 'on') return;

    var items = Array.prototype.slice.call(
      this.media.querySelectorAll('.product-drawer__media-item')
    );
    if (items.length === 0) return;

    this.info = this.root.querySelector('.product-drawer__info');

    var mg = document.createElement('div');
    mg.className = 'cz-mgallery';
    var track = document.createElement('div');
    track.className = 'cz-mgallery__track';
    mg.appendChild(track);

    var self = this;
    this._slides = [];
    items.forEach(function (item) {
      self._detach(item);
      var slide = document.createElement('div');
      slide.className = 'cz-mgallery__slide';
      slide.appendChild(item);
      track.appendChild(slide);
      self._slides.push(slide);
    });

    // Nasconde la griglia desktop ormai svuotata (ripristinata nel teardown).
    var grid = this.media.querySelector('.product-drawer__media-grid');
    if (grid && !grid.hidden) {
      grid.hidden = true;
      grid.dataset.czHidden = '1';
    }

    this.media.insertBefore(mg, this.media.firstChild);
    this._mgallery = mg;
    this._track = track;

    if (this.info) {
      this._detach(this.info);
      this.media.insertBefore(this.info, mg.nextSibling);
    }

    this._buildNav();
    this._buildPager();
    this._bindTapGuard();
    this.root.dataset.czMgallery = 'on';
  };

  CzMobileGallery.prototype._teardown = function () {
    if (this.root.dataset.czMgallery !== 'on') return;

    // Ripristina ogni nodo spostato al suo posto esatto (ordine inverso).
    for (var i = this._moved.length - 1; i >= 0; i--) {
      var m = this._moved[i];
      if (m.ph && m.ph.parentNode) m.ph.parentNode.replaceChild(m.node, m.ph);
    }
    this._moved = [];

    var grid = this.media && this.media.querySelector('.product-drawer__media-grid');
    if (grid && grid.dataset.czHidden === '1') {
      grid.hidden = false;
      delete grid.dataset.czHidden;
    }

    if (this._mgallery && this._mgallery.parentNode) {
      this._mgallery.parentNode.removeChild(this._mgallery);
    }
    if (this._track && this._onScroll) {
      this._track.removeEventListener('scroll', this._onScroll);
    }
    if (this._mgallery && this._onPointerDown) {
      this._mgallery.removeEventListener('pointerdown', this._onPointerDown);
      this._mgallery.removeEventListener('pointermove', this._onPointerMove);
    }
    if (this._mgallery && this._onClickCapture) {
      this._mgallery.removeEventListener('click', this._onClickCapture, true);
    }
    if (this._raf) { cancelAnimationFrame(this._raf); this._raf = 0; }
    this._onScroll = null;
    this._onPointerDown = null;
    this._onPointerMove = null;
    this._onClickCapture = null;
    this._prevBtn = null;
    this._nextBtn = null;
    this._dots = null;
    this._mgallery = null;
    this._track = null;
    this._slides = [];
    this.info = null;
    delete this.root.dataset.czMgallery;
  };

  function init() {
    var root = document.querySelector('.product-drawer--page');
    if (!root) return;
    window.czMobileGallery = new CzMobileGallery(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
